import { BaseApi } from '../../api/apiBase'

interface TrackEventPayload {
  eventName?: string
  source?: string
  livestreamName?: string
  isLive?: boolean
  timestamp?: string
  reason?: string
  watchDuration?: number
  quality?: string
  duration?: number
  link?: string
  streamType?: string
  properties?: Record<string, any>
}

interface BatchTrackEvent extends TrackEventPayload {
  livestreamId: string
}

interface TrackResponse {
  success: boolean
  message?: string
  eventName?: string
  livestreamId?: string
  trackedAt?: string
  error?: string
}

interface BatchTrackResponse {
  success: boolean
  trackedCount: number
  results: Array<{
    livestreamId: string
    eventName: string
    success: boolean
  }>
  errors: Array<{
    livestreamId: string
    eventName: string
    error: string
  }>
  trackedAt: string
}

class LivestreamTrackingApi extends BaseApi {
  /**
   * Track a single event for a livestream
   */
  async trackEvent(
    eventSlug: string,
    livestreamId: string,
    payload: TrackEventPayload = {}
  ): Promise<TrackResponse> {
    // Use postSimpleJson for simple message responses
    return this.postSimpleJson(
      `/events/${eventSlug}/livestream_tracking/${livestreamId}/track`,
      payload
    )
  }

  /**
   * Track multiple events in a single request
   */
  async batchTrack(
    eventSlug: string,
    events: BatchTrackEvent[]
  ): Promise<BatchTrackResponse> {
    // Use postSimpleJson for simple message responses
    return this.postSimpleJson(
      `/events/${eventSlug}/livestream_tracking/batch_track`,
      { events }
    )
  }
}

export const livestreamTrackingApi = new LivestreamTrackingApi()

// Export types
export type { TrackEventPayload, BatchTrackEvent, TrackResponse, BatchTrackResponse }